module.exports = __webpack_public_path__ + "202408221624/img/home_iomic_3.f6af2694.png";